export type PaymentReturnTranslation = {
  cancelledTitle: string;
  cancelledCta: string;
  cancelledMessage: string;
  awaitEmailTitle: string;
  awaitEmailMessage: string;
  awaitEmailSupport: string;
  successTitle: string;
  successMessage: string;
  /** Uses the {gamename} placeholder. */
  successEnjoy: string;
  adFree: string;
  errorTitle: string;
  errorMessage: string;
  activeSubscriptionTitle: string;
  activeSubscriptionMessage: string;
  /** Uses the {gamename} and {email} placeholders. */
  activeSubscriptionAdsNotice: string;
  activeSubscriptionCta: string;
};

export const paymentReturnTranslations = {
  en: {
    cancelledTitle: 'No problem if you changed your mind',
    cancelledCta: 'Try again',
    cancelledMessage: 'Your purchase was cancelled, and you have not been charged',
    awaitEmailTitle: 'Check your inbox',
    awaitEmailMessage:
      'Your purchase went through! We sent an email from Teuteuf to help you log in and unlock the Passport experience',
    awaitEmailSupport: 'Any issues? Contact',
    successTitle: 'Thank you',
    successMessage:
      'Thank you for supporting Teuteuf. You have helped our small studio keep making games for everyone.',
    successEnjoy: 'You can now enjoy {gamename} and 18 more games',
    adFree: 'ad free',
    errorTitle: 'Unexpected error',
    errorMessage: 'Please try again later or email',
    activeSubscriptionTitle: 'You already have an active subscription',
    activeSubscriptionMessage: "We've logged you in so you can enjoy your premium benefits.",
    activeSubscriptionAdsNotice:
      'If you still see adverts, {gamename} might not be included. Please email {email} if you have any questions.',
    activeSubscriptionCta: 'Manage your subscription'
  }
} as const satisfies Record<string, PaymentReturnTranslation>;

export type PaymentReturnLanguage = keyof typeof paymentReturnTranslations;

const fallbackLanguage: PaymentReturnLanguage = 'en';

export function getPaymentReturnTranslations(lang: string | undefined): PaymentReturnTranslation {
  if (lang && lang in paymentReturnTranslations) {
    return paymentReturnTranslations[lang as PaymentReturnLanguage];
  }
  return paymentReturnTranslations[fallbackLanguage];
}
